import { render, staticRenderFns } from "./GuardDashboard.vue?vue&type=template&id=0392541a&scoped=true"
import script from "./GuardDashboard.vue?vue&type=script&lang=js"
export * from "./GuardDashboard.vue?vue&type=script&lang=js"
import style0 from "./GuardDashboard.vue?vue&type=style&index=0&id=0392541a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392541a",
  null
  
)

export default component.exports